import * as Styled from './styled'
import { MusicTabContent } from './content'
import { AudioTabActions } from './actions'
import { translate } from 'utils/translations'
import Text from 'common-components/Text'
import { useState } from 'react'
import { AudioContentProvider } from './context'
import { T } from 'consts/translationKeys'

export const AudioContent: React.FC = () => {
  const [activeGenreName, setActiveGenreName] = useState('')

  const isHideAudioTabActions = activeGenreName

  return (
    <Styled.MusicTabContainer>
      <Text type="h1" color="secondaryDark">
        {translate(T.AUDIO_LABEL)}
      </Text>
      <AudioContentProvider>
        {!isHideAudioTabActions && <AudioTabActions />}

        <MusicTabContent
          activeGenreName={activeGenreName}
          setActiveGenreName={setActiveGenreName}
        />
      </AudioContentProvider>
    </Styled.MusicTabContainer>
  )
}
